export const stepperData = [
  {
    title: 'smart-contract-development.stepper.first-step.title',
    timeline: 'smart-contract-development.stepper.first-step.timeline',
    content: 'smart-contract-development.stepper.first-step.content',
  },
  {
    title: 'smart-contract-development.stepper.second-step.title',
    timeline: 'smart-contract-development.stepper.second-step.timeline',
    content: 'smart-contract-development.stepper.second-step.content',
  },
  {
    title: 'smart-contract-development.stepper.third-step.title',
    timeline: 'smart-contract-development.stepper.third-step.timeline',
    content: 'smart-contract-development.stepper.third-step.content',
  },
  {
    title: 'smart-contract-development.stepper.fourth-step.title',
    timeline: 'smart-contract-development.stepper.fourth-step.timeline',
    content: 'smart-contract-development.stepper.fourth-step.content',
  },
]
